import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[ftState]',
    standalone: true,
})
export class StateDirective {
	viewContainerRef = inject(ViewContainerRef);
}
